import React from "react";

const PanelTitle = (props: { children: React.ReactNode }) => {
    return (
        <h3 className="an-h3">
            {props.children}
        </h3>
    );
};

export default PanelTitle;
